module.exports = __webpack_public_path__ + "static/media/partner04.81292e3c.svg";